export const outPutData = {
    ATR1: {
        row1: {
            rowClassName: '',
            rowStyle: {},

            internalComponents: {
                atrMotor1: {
                    ImgClassName: 'imgStyle_v1',
                    altText: 'atrMotor1',
                    activeImgSrc: 'activeIndividual',
                    inActiveImgSrc: 'inactiveIndividual',
                    imgTagStyle: { height: 'auto' },
                    reduxName: 'isAtrMotor1',
                },
                atrMotor2: {
                    ImgClassName: 'imgStyle_v1',
                    altText: 'atrMotor2',
                    activeImgSrc: 'activeIndividual',
                    inActiveImgSrc: 'inactiveIndividual',
                    imgTagStyle: { height: 'auto' },
                    reduxName: 'isAtrMotor2',
                },
                atrMotor3: {
                    ImgClassName: 'imgStyle_v1',
                    altText: 'atrMotor3',
                    activeImgSrc: 'activeIndividual',
                    inActiveImgSrc: 'inactiveIndividual',
                    imgTagStyle: { height: 'auto' },
                    reduxName: 'isAtrMotor3',
                },
            },
        },
    },
    // Woof expansion kit outputs — individual servo & action group
    // (mirrors the Humanoid-style outputs, rendered in this PC screen).
    WOOFKIT1: {
        row1: {
            rowClassName: '',
            rowStyle: {},

            internalComponents: {
                individualServo: {
                    ImgClassName: 'imgStyle_v1',
                    altText: 'individualServo',
                    activeImgSrc: 'activeIndividual',
                    inActiveImgSrc: 'inactiveIndividual',
                    imgTagStyle: { height: 'auto' },
                    reduxName: 'isIndivdualServo',
                },
                actionGroup: {
                    ImgClassName: 'imgStyle_v1',
                    altText: 'actionGroup',
                    activeImgSrc: 'activeActionGroup',
                    inActiveImgSrc: 'inactiveActionGroup',
                    imgTagStyle: { height: 'auto' },
                    reduxName: 'isActionGroup',
                },
                oled: {
                    ImgClassName: 'imgStyle_v1',
                    altText: 'oled',
                    activeImgSrc: 'activeWoofOledBtn',
                    inActiveImgSrc: 'inactiveWoofOledBtn',
                    imgTagStyle: { height: 'auto' },
                    reduxName: 'isWoofOled',
                },
            },
        },
    },
}

export const tostMessages = {
    atrMotor1: {
        tostDivId: 'snackbar_atrMotor1',
        tostDivClass: 'bottom0',
        activeMessage: ' - Motor 1 selected',
        InactiveMessage: ' - Motor 1 deselected',
    },
    atrMotor2: {
        tostDivId: 'snackbar_atrMotor2',
        tostDivClass: 'bottom0',
        activeMessage: ' - Motor 2 selected',
        InactiveMessage: ' - Motor 2 deselected',
    },
    atrMotor3: {
        tostDivId: 'snackbar_atrMotor3',
        tostDivClass: 'bottom0',
        activeMessage: ' - Motor 3 selected',
        InactiveMessage: ' - Motor 3 deselected',
    },
    individualServo: {
        tostDivId: 'snackbar_woofIndividualServo',
        tostDivClass: 'bottom0',
        activeMessage: ' - Individual Servo selected',
        InactiveMessage: ' - Individual Servo deselected',
    },
    actionGroup: {
        tostDivId: 'snackbar_woofActionGroup',
        tostDivClass: 'bottom0',
        activeMessage: ' - Action Group selected',
        InactiveMessage: ' - Action Group deselected',
    },
    oled: {
        tostDivId: 'snackbar_woofOled',
        tostDivClass: 'bottom0',
        activeMessage: ' - OLED selected',
        InactiveMessage: ' - OLED deselected',
    },
}
